import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import BreadCrumb from './breadcrumb';

export default class SearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <BreadCrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-3">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="string"
                            margin="dense"
                            onChange={(e) => this.props.onSearch(e.target.value)}
                            value={this.props.searchValue}
                        />
                    </div>
                    <div className="col-md-2">
                        <button 
                            className="btn btn-primary button-info-grid" 
                            onClick={() => {
                                this.props.onSearch('');
                                document.getElementById('reset-form').value = '';
                            }}
                        >
                            <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                        </button>
                    </div>
                    <div className="col-md-7" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            <button
                                className="btn btn-primary button-info-grid"
                                onClick={() => this.props.onAddFlag()}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i> Add Flag
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}